require('../../modules/es6.object.keys');
module.exports = require('../../modules/$.core').Object.keys;


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/fn/object/keys.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/fn/object/keys.js
// module chunks = 0